"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlToText = void 0;
const html_entities_1 = require("html-entities");
const htmlToTextLib = require("html-to-text");
function htmlToText(html, options) {
    var _a, _b;
    return (_b = (_a = (0, html_entities_1.decode)(htmlToTextLib.htmlToText(html, options))) === null || _a === void 0 ? void 0 : _a.replace(/\n{2,}/g, '\n\n')) === null || _b === void 0 ? void 0 : _b.trim();
}
exports.htmlToText = htmlToText;
//# sourceMappingURL=html-to-text.js.map